import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from '@/types';
import axios from 'axios';
import moment from 'moment';
import WordList from '@/assets/word-dictionary';

Vue.use(Vuex);

function scoreWord(word: string) {
  if (typeof word === 'undefined') { return 0; }
  let score = 0;
  // 1 point for every letter
  score += word.length;
  // extra point for letters with less than 5% frequency
  const highScoreLetters = word
    .match(/[b,c,d,f,g,h,j,k,m,p,q,u,v,w,x,y,z]/g) || [];
  score += highScoreLetters.length;
  return score;
}

const store: StoreOptions<RootState> = {
  state: {
    gameStarted: false,
    letters: [],
    currentWord: '',
    capturing: false,
    completedWords: [],
    triedWords: [],
    gameEndTime: moment(),
    gameTimer: 0,
    timeRemaining: '',
    score: 0,
    wordDictionary: '',
  },
  getters: {
    lastWordScore: state =>
      scoreWord(state.completedWords[state.completedWords.length-1]),
  },
  mutations: {
    loadWordDictionary(state: RootState, wordDictionary: string) {
      Object.assign(state, { wordDictionary });
    },
    setLetters(state: RootState, letters: string[]) {
      state.letters.push(...letters);
    },
    startGame(state: RootState, gameEndTime: moment.Moment) {
      Object.assign(state, {
        gameStarted: true,
        score: 0,
        gameEndTime,
        triedWords: [],
        completedWords: [],
      });
    },
    stopGame(state: RootState) {
      Object.assign(state, {
        gameStarted: false,
        timeRemaining: 'Game Over',
        letters: [],
      });
      clearTimeout(state.gameTimer);
    },
    addLetter(state: RootState, letter: string) {
      Object.assign(state, { currentWord: state.currentWord + letter });
    },
    startCapturing(state: RootState) {
      Object.assign(state, { capturing: true });
    },
    stopCapturing(state: RootState) {
      Object.assign(state, { capturing: false, currentWord: '' });
    },
    tryWord(state: RootState, word: string) {
      state.triedWords.push(word);
    },
    addWord(state: RootState, word: string) {
      state.completedWords.push(word);
      Object.assign(state, { score: state.score + scoreWord(word) });
    },
    addTimer(state: RootState, gameTimer: number) {
      Object.assign(state, { gameTimer });
    },
    updateTimeRemaining(state: RootState, timeRemaining: string) {
      Object.assign(state, { timeRemaining });
    },
  },
  actions: {
    loadWordDictionary({ commit }, wordDictionary: string) {
      commit('loadWordDictionary', wordDictionary);
    },
    setLetters({ commit }, letters: string[]) {
      commit('setLetters', letters);
    },
    startGame({ commit, dispatch }) {
      const timeRemaining = '2 : 00';
      const gameTimer: number = window.setInterval(() => {
        dispatch('updateTimer');
      }, 1000);
      const gameEndTime: moment.Moment = moment().add(2, 'minutes').add(1, 'second');
      commit('addTimer', gameTimer);
      commit('updateTimeRemaining', timeRemaining);
      commit('startGame', gameEndTime);
    },
    updateTimer({ state, commit, dispatch }) {
      const duration = moment.duration(state.gameEndTime.diff(moment()));
      if (duration.asSeconds() <= 0) {
        dispatch('gameOver');
      } else {
        const timeRemaining = `${duration.minutes()} : ${duration.seconds()}`;
        commit('updateTimeRemaining', timeRemaining);
      }
    },
    gameOver({ commit }) {
      commit('stopGame');
    },
    startCapturing({ commit }) {
      commit('startCapturing');
    },
    stopCapturing({ commit }) {
      commit('stopCapturing');
    },
    addLetter({ commit }, letter) {
      commit('addLetter', letter);
    },
    tryWord({ state, dispatch, commit }, word) {
      if (state.gameStarted) {
        commit('tryWord', word);
        if (word.length >= 2
          && WordList[word]) {
          dispatch('addWord', word);
        }
        // commit('tryWord', word);
        // axios.get(`https://api.datamuse.com/words/?max=1&md=d&sp=${word}`)
        //   .then((response) => {
        //     if (response.data.length > 0
        //       && response.data[0].word === word
        //       && response.data[0].defs && response.data[0].defs.length > 0) {
        //       dispatch('addWord', word);
        //     }
        //   });
      }
    },
    addWord({ commit }, word) {
      commit('addWord', word);
    },
  },
};

export default new Vuex.Store<RootState>(store);
